export enum ENV {
  LOCAL = 'local',
  LOCAL_PREVIEW = 'localPreview',
  PREVIEW = 'preview',
  STAGING = 'staging',
  PRODUCTION = 'production',
}

export function isLocal(): boolean {
  return ENVIRONMENT === ENV.LOCAL;
}

export function isLocalPreview(): boolean {
  return ENVIRONMENT === ENV.LOCAL_PREVIEW;
}

export function isAnyLocal(): boolean {
  return isLocal() || isLocalPreview();
}

export function isPreview(): boolean {
  return ENVIRONMENT === ENV.PREVIEW;
}

export function isStaging(): boolean {
  return ENVIRONMENT === ENV.STAGING;
}

export function isProduction(): boolean {
  return ENVIRONMENT === ENV.PRODUCTION;
}

export function isEuDomain(): boolean {
  try {
    const url = new URL(STATIC_HOST_URL_EU);
    let staticHostUrl: any = url.hostname;
    staticHostUrl = staticHostUrl.split('.');
    staticHostUrl.shift(); // remove the 'app.' part of URL
    staticHostUrl = staticHostUrl.join('.');
    return location.hostname.endsWith(staticHostUrl);
  } catch (err) {
    return false;
  }
}
// added for debugging purposes, we can remove this later
console.log('isEuDomain: ' + isEuDomain());

export function getRegion(): string {
  return isEuDomain() ? 'eu' : 'us';
}

export function getApiUrl(): string {
  return isEuDomain() ? API_URL_EU : API_URL;
}

export function getAccountUrl(): string {
  return isEuDomain() ? ACCOUNT_URL_EU : ACCOUNT_URL;
}

export function getServerUrl(): string {
  return isEuDomain() ? SERVER_URL_EU : SERVER_URL;
}

export function getStaticHostUrl() {
  return isEuDomain() ? STATIC_HOST_URL_EU : STATIC_HOST_URL;
}

export function getWebsiteUrl() {
  return isEuDomain() ? WEBSITE_URL_EU : WEBSITE_URL;
}

export function getSendBirdAppId(): string {
  return isEuDomain() ? SENDBIRD_EU_APP_ID : SENDBIRD_APP_ID;
}

export function getGoogleMapsKey(): string {
  return isEuDomain() ? GOOGLE_MAPS_KEY_EU : GOOGLE_MAPS_KEY;
}
